import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DynamicForm from "components/DynamicForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createPaymentAssignmentThunk,
  deletePaymentsForMachineThunk,
  getPaymentsForMachineThunk,
  getPaymentTypesThunk,
} from "store/reducers/payments";

const PaymentInWizard = ({
  handleNext,
  handleSkip,
  paymentStepCompleted,
  setPaymentStepCompleted,
  machine,
  fullGrid = false,
}) => {
  const [payment, setPayment] = React.useState("");
  const [production, setProduction] = React.useState(true);
  const handlePaymentChange = (event) => {
    setPayment(event.target.value);
  };
  const isSmallSCreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const paymentState = useSelector((state) => state.payments);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPaymentTypesThunk());
  }, [dispatch]);

  useEffect(() => {
    if (paymentState.createPaymentAssignmentSuccess) {
      dispatch(getPaymentsForMachineThunk(machine.id));
      if (!fullGrid) {
        setPaymentStepCompleted(true);
      }
    }
  }, [
    machine.id,
    dispatch,
    paymentState.createPaymentAssignmentSuccess,
    setPaymentStepCompleted,
    fullGrid,
  ]);

  const onCredentialFormatSubmit = (data) => {
    const payment_request = {
      machine: machine.id,
      payment: payment.id,
      paymentFull: payment,
      logic: payment.code,
      authentication: data,
      production,
    };
    // console.log(payment_request);
    dispatch(createPaymentAssignmentThunk(payment_request));
  };

  return (
    <>
      <Box display="flex">
        <FormControl sx={{ minWidth: 160 }} size="small">
          <InputLabel id="payment">Choose Payment</InputLabel>
          <Select
            id="id-payment-select"
            value={payment}
            label="Choose payment"
            onChange={handlePaymentChange}
          >
            <MenuItem value={null}>
              <em>None</em>
            </MenuItem>
            {paymentState.paymentTypes.map((payment) => (
              <MenuItem key={payment.id} value={payment}>
                {payment.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {(paymentState.paymentsForMachine[machine.id]?.length ?? 0) > 0 &&
        !fullGrid && (
          <>
            <Typography variant="h5" color="gray" marginTop={1}>
              Following payments assigned to this machine
            </Typography>
            {paymentState.paymentsForMachine[machine.id]?.map((paymentItem) => (
              <Chip
                key={paymentItem.id}
                label={paymentItem.name}
                sx={{ mt: 2 }}
                onDelete={() =>
                  dispatch(
                    deletePaymentsForMachineThunk({
                      machine: machine.id,
                      payment: paymentItem.id,
                    })
                  )
                }
              />
            ))}
          </>
        )}
      {payment && (
        <>
          <Typography variant="h6" color="gray" marginTop={1}>
            Do you want to add {payment.name} to this machine ?
          </Typography>

          <div>
            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  name="remember"
                  checked={production}
                  value={production}
                  color="primary"
                />
              }
              label="Production"
              onChange={(e) => setProduction(e.target.checked)}
              name="remember"
            />
          </div>

          {payment.credential_format ? (
            <>
              <Typography variant="caption" color="gray">
                {payment.name} required the following details to proceed
              </Typography>

              <DynamicForm
                items={payment.credential_format}
                buttonText="Submit"
                buttonType="outlined"
                grid={{ xs: 12, md: fullGrid ? 12 : 6, lg: fullGrid ? 12 : 4 }}
                loading={paymentState.createPaymentAssignmentLoading}
                onSubmit={onCredentialFormatSubmit}
                sx={{ mt: 2 }}
              />

              {paymentState.createPaymentAssignmentError && (
                <Alert severity="error">Error occurred</Alert>
              )}
              {paymentState.createPaymentAssignmentSuccess && (
                <Alert sx={{ mt: 3 }} severity="success">
                  Success
                </Alert>
              )}
            </>
          ) : (
            <>
              <LoadingButton
                loading={paymentState.createPaymentAssignmentLoading}
                variant="outlined"
                type="submit"
                onClick={() => onCredentialFormatSubmit(null)}
              >
                Add this payment
              </LoadingButton>
            </>
          )}
        </>
      )}
      {!fullGrid && (
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                marginTop: 3,
              }}
            >
              {paymentStepCompleted && (
                <LoadingButton
                  variant="contained"
                  fullWidth={isSmallSCreen}
                  type="submit"
                  onClick={handleNext}
                >
                  Continue
                </LoadingButton>
              )}
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default PaymentInWizard;
